import { render, staticRenderFns } from "./dictionaryManage.vue?vue&type=template&id=63629a60&scoped=true"
import script from "./dictionaryManage.vue?vue&type=script&lang=js"
export * from "./dictionaryManage.vue?vue&type=script&lang=js"
import style0 from "./dictionaryManage.vue?vue&type=style&index=0&id=63629a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63629a60",
  null
  
)

export default component.exports